import { api, seg } from './client';

/**
 * How many discoverable teams a program has, how many it's allowed, and what buying
 * one more slot costs right now — mirrors the server's `TeamCapacityDto`. `capacity`
 * is always `coachCount + activeSlots`. Computed regardless of whether it's currently
 * enforced (see `AdditionalTeamSubscriptionService`, a no-op while billing is off).
 */
export interface TeamCapacity {
  discoverableTeamCount: number;
  coachCount: number;
  activeSlots: number;
  capacity: number;
  additionalTeamSubscriptionPriceCents: number;
  /** Whether the cap is actually being refused against right now (billing enabled). */
  enforced: boolean;
}

export const fetchTeamCapacity = (accountId: string): Promise<TeamCapacity> =>
  api.get<TeamCapacity>(`/saved-teams/capacity?accountId=${seg(accountId)}`);
